import React from "react";
import {BrowserRouter as Router} from "react-router-dom";

import "./App.scss";
import Routes from "./routes";
import {getCustomerSlotDetails} from "./services/SessionStorage";
import {setTimeZone} from "./services/Format/Date";
import {DEFAULT_THEME} from "./constants";

const sessionData = getCustomerSlotDetails();

export function setTheme(theme) {
  document.documentElement.className = "";
  document.documentElement.classList.add(`theme-${theme}`);
}

function updateThemeOnRefresh() {
  let currentTheme = DEFAULT_THEME;
  if (sessionData && sessionData.theme) {
    currentTheme = sessionData.theme;
  }
  setTheme(currentTheme);
}

function updateTimeZoneOnRefresh() {
  if (sessionData && sessionData.country) setTimeZone(sessionData.country);
  else setTimeZone();
}

updateThemeOnRefresh();
updateTimeZoneOnRefresh();

function App() {
  return (
    <Router>
      <Routes />
    </Router>
  );
}

export default App;
